/**
 *权限路由配置
 */
// 进度条插件
import NProgress from 'nprogress'
import router, { loginRouter } from './router'
import 'nprogress/nprogress.css'
import store from '@/store'
import { ElMessage } from 'element-plus'
import { setSessionItem, getSessionItem } from '@/utils/sessionstorage'
import { getLocalItem } from '@/utils/localStorage'
import { getNavAndLeftMenuData } from '@/utils/menu'
import { scrollTop } from '@/utils'

// 路由白名单
const whiteList = store.getters['moduleCommon/getWhileArrRouter']

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  // 刷新的时候获取最新的本地缓存信息
  if (from.name === undefined) {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i)
      setSessionItem(key, getLocalItem(key))
    }
  }
  // 判断用户是否已经在其他页面退出登录了
  if (
    !getLocalItem('zl-user-token') ||
    (getLocalItem('zl-user-token') &&
      typeof getLocalItem('zl-user-token') === 'string' &&
      getLocalItem('zl-user-token').indexOf(getLocalItem('zl-login-date')) === -1)
  ) {
    store.commit('moduleCommon/SET_TOKEN', null)
  }
  if (store.state.moduleCommon.token) {
    if (to.path === '/login') {
      next()
    } else {
      // 触发获取用户信息，并获取用户当前权限
      if (!store.getters['moduleCommon/getPermissionRouter']) {
        // 利用 addRoute 循环添加
        const filterRoutes = loginRouter()
        // 有权限路由数据进行存储
        store.commit('moduleCommon/PREMISSION_ROUTER', filterRoutes)
        if (filterRoutes) {
          filterRoutes.forEach((item) => {
            router.addRoute(item)
          })
        }
        // 添加完动态路由之后，需要在进行一次主动跳转
        return next(to.redirectedFrom?.fullPath || to.path)
      }
      // 刚触发刷新
      if (to.redirectedFrom) {
        to.fullPath = to.redirectedFrom.fullPath
        to.query = to.redirectedFrom.query
      }
      next()
    }
  } else {
    // 没有token的情况下，可以进入白名单
    if (router.hasRoute(to.name) || whiteList.indexOf(to.path) > -1) {
      next()
    } else {
      next('/404')
    }
  }
})

// 跳转后的处理
router.afterEach((to, from) => {
  const sign = ['adminRegister', 'accountOpenType']
  const login = ['login']
  if (sign.includes(to.name)) {
    document.title = '注册'
  } else if (login.includes(to.name)) {
    document.title = '登录'
  } else {
    document.title = '众禄投资通'
  }
  // 获取当前跳转的菜单
  if (to?.meta) {
    getNavAndLeftMenuData({ moduleKey: to.meta?.moduleKey, sideActiveName: to.name, path: to?.path })
  }
  // 清除上一次的页面信息
  store.commit('moduleCommon/PAGE_TITLE', '')
  NProgress.done()
  // 重置页面高度
  scrollTop()
})

const setTime = () => {
  setSessionItem('zl-operation-time', new Date().getTime())
}

const route = useRoute()
const time = 30 * 60 * 1000
// 测试30分钟内是否存在操作
const modifyTImeOperation = () => {
  if (route && route.name === 'login') {
    setTime()
  } else {
    const curTime = new Date().getTime()
    const beforeTime = getSessionItem('zl-operation-time')
    if (beforeTime && curTime - beforeTime > time) {
      ElMessage({
        message: '长时间未操作，请重新登录！',
        type: 'warning'
      })
      router.push({
        path: '/login'
      })
    }
  }
}

let onTimer = 0
// 触发 定时监听页面事件
const OntimerEvent = () => {
  onTimer = setInterval(modifyTImeOperation, time)
}

// 监听鼠标按下的操作
// window.onload = function () {
//   window.document.onmousedown = function () {
//     setTime()
//   }
//   window.document.onkeydown = function () {
//     setTime()
//   }
// }
